import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { CardWithLimitProp } from '@/features/account-management/types';

export interface SetCardLimitModalProps {
  onLayout: (event: any) => void;
}

export enum SetCardLimitStackRoutes {
  Main = 'main',
  DailyPurchaseLimit = 'dailyPurchaseLimit',
  Confirmation = 'confirmation',
  Placed = 'placed'
}

export type SetCardLimitStackParamList = {
  [SetCardLimitStackRoutes.Main]: SetCardLimitModalProps & {
    account: string;
    tab?: number;
    onDailyLimitType?: (value: string) => void;
    record?: CardWithLimitProp;
    func?: (
      cardId: string,
      atmLimit?: number,
      purchaseLimit?: number,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    refresh?: () => void;
  };
  [SetCardLimitStackRoutes.DailyPurchaseLimit]: SetCardLimitModalProps & {
    account: string;
    tab?: number;
    onData?: (data: any) => void;
    dailyLimitType: string | undefined;
    record?: CardWithLimitProp;
    func?: (
      cardId: string,
      atmLimit?: number,
      purchaseLimit?: number,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [SetCardLimitStackRoutes.Confirmation]: SetCardLimitModalProps & {
    account: string;
    tab?: number;
    data: any;
    dailyLimitType: string | undefined;
    record?: CardWithLimitProp;
    func?: (
      cardId: string,
      atmLimit?: number,
      purchaseLimit?: number,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [SetCardLimitStackRoutes.Placed]: SetCardLimitModalProps & {
    account: string;
    tab?: number;
    data: any;
    dailyLimitType: string | undefined;
    record?: CardWithLimitProp;
    returnData?: any;
    refresh?: () => void;
  };
};

export type SetCardLimitStackScreenProps<Screen extends keyof SetCardLimitStackParamList> = NativeStackScreenProps<
  SetCardLimitStackParamList,
  Screen
>;
